/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irreversibleactionsforyouraccount4Inputs */

const en_irreversibleactionsforyouraccount4 = /** @type {(inputs: Irreversibleactionsforyouraccount4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irreversible actions for your account`)
};

const de_irreversibleactionsforyouraccount4 = /** @type {(inputs: Irreversibleactionsforyouraccount4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endgültige Aktionen für dein Konto`)
};

/**
* | output |
* | --- |
* | "Irreversible actions for your account" |
*
* @param {Irreversibleactionsforyouraccount4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const irreversibleactionsforyouraccount4 = /** @type {((inputs?: Irreversibleactionsforyouraccount4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irreversibleactionsforyouraccount4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_irreversibleactionsforyouraccount4(inputs)
	return de_irreversibleactionsforyouraccount4(inputs)
});
export { irreversibleactionsforyouraccount4 as "irreversibleActionsForYourAccount" }